export default __webpack_public_path__ + "empty-state-icon.png";